import "./About.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheManBehindTheMessage from "./sections/TheManBehindTheMessage";
import LeadershipMilestones from "./sections/LeadershipMilestones";
import TrustedByGlobalBrands from "./sections/TrustedByGlobalBrands";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <MainNavigation />
      <TheManBehindTheMessage />
      <LeadershipMilestones />
      <TrustedByGlobalBrands />
      <Footer />
    </div>;
}